<template>
  <span>
    <div v-if="status === 'Verified'">
      <span class="grey--text">Verified</span>
    </div>
    <div v-else-if="status === 'Requested'">
      <span>Requested</span>
    </div>
    <div v-else-if="status === 'Pending'">
      <span class="orange--text text--darken-1">Pending</span>
    </div>
    <div v-else-if="status === 'Removed'">
      <span class="red--text text--accent-2">Removed</span>
    </div>
    <div v-else>-</div>
  </span>
</template>

<script>
import { Vue } from 'vue-property-decorator';

export default Vue.extend({
  props: ['status'],
  data: () => ({}),
});
</script>
